import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const AboutUsPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "about-us-page" */ './about-us.page.js'),
	modules: ['./about-us.page.js'],
	webpack: () => [require.resolveWeak('./about-us.page.js')],
	loading: CustomLoadableLoading,
});

export default AboutUsPageAsync;
